module.exports = __webpack_public_path__ + "img/ust.66f1b147.svg";